// eslint-disable-next-line no-use-before-define
import React from 'react';
import { Spin } from 'antd';

const PageLoading = () => (
  <div
    style={{
      paddingTop: 100,
      textAlign: 'center',
    }}
  >
    <Spin size="large" />
  </div>
);

export default PageLoading;
